<template>
  <section
    :class="['s-section',
             type && `s-section--${type}`,
             isSubSection && 's-section--sub']"
  >
    <div
      v-if="!isSubSection"
      class="container"
    >
      <div
        v-if="title || subtitle"
        :class="!isCentered && 'row'"
      >
        <div :class="[!isCentered && 'col-xl-9 ml-auto']">
          <div :class="['s-section__header', !$slots && 'mb-0']">
            <h2
              v-if="title"
              :class="['s-section__title', isCentered && 's-section__title--center']"
              v-html="title"
            ></h2>
            <div
              v-if="subtitle"
              :class="['s-section__subtitle', isCentered && 's-section__subtitle--center']"
              v-html="subtitle"
            ></div>
          </div>
        </div>
      </div>

      <div
        v-if="!hasOutsideContent && $slots"
        class="s-section__content"
      >
        <slot></slot>
      </div>
    </div>

    <div
      v-else
      :class="(title || subtitle) && 'row'"
    >
      <div
        v-if="title || subtitle"
        class="col-xl-3"
      >
        <template v-if="!subtitle">
          <div class="s-section__header mb-xl-0">
            <h3
              class="s-section__title"
              v-html="title"
            ></h3>
          </div>
        </template>
        <h3
          v-else
          class="s-section__title"
          v-html="title"
        ></h3>
      </div>

      <div
        v-if="title || subtitle"
        class="col-xl-9"
      >
        <div
          v-if="subtitle"
          :class="['s-section__header', !$slots && 'mb-0']"
        >
          <div
            class="s-section__subtitle"
            v-html="subtitle"
          ></div>
        </div>

        <div
          v-if="$slots"
          class="s-section__content"
        >
          <slot></slot>
        </div>
      </div>

      <div
        v-if="!title && !subtitle && $slots"
        class="s-section__content"
      >
        <slot></slot>
      </div>
    </div>

    <div
      v-if="hasOutsideContent && !isSubSection && $slots"
      class="s-section__content"
    >
      <slot></slot>
    </div>
  </section>
</template>

<script>
export default {
  name: 'SSection',
  props: {
    hasOutsideContent: {
      type: Boolean,
      default: false
    },
    isSubSection: {
      type: Boolean,
      default: false
    },
    isCentered: {
      type: Boolean,
      default: false
    },
    type: {
      type: String,
      default: '',
      validator(value) {
        return ['bordered', 'gray', 'inverse', 'bordered-top', ''].indexOf(value) !== -1
      }
    },
    title: {
      type: String,
      default: ''
    },
    subtitle: {
      type: String,
      default: ''
    }
  }
}

</script>

<style lang="scss">
.s-section {
  padding: 48px 0;

  @media (max-width: $breakpoint-lg) {
    padding-top: 32px;
    padding-bottom: 32px;
  }

  @media (max-width: $breakpoint-md) {
    padding-top: 24px;
    padding-bottom: 24px;
  }
}

.s-section:last-of-type {
  margin-bottom: 48px;

  @media (max-width: $breakpoint-lg) {
    margin-bottom: 32px;
  }

  @media (max-width: $breakpoint-md) {
    margin-bottom: 24px;
  }
}

.banners + .s-section {
  @media (max-width: $breakpoint-lg) {
    margin-top: 8px;
  }

  @media (max-width: $breakpoint-md) {
    margin-top: 16px;
  }
}

.banners + .s-section--inverse, .banners + .s-section--bordered, .banners + .s-section--gray {
  margin-top: 0;
}

.teaser + .s-section {
  @media (max-width: $breakpoint-lg) {
    margin-top: 8px;
  }

  @media (max-width: $breakpoint-md) {
    margin-top: 16px;
  }
}

.teaser + .s-section--inverse, .teaser + .s-section--bordered, .teaser + .s-section--gray {
  margin-top: 0;
}

.teaser--with-text + .s-section--inverse, .teaser--with-text + .s-section--bordered, .teaser--with-text + .s-section--gray {
  margin-top: 48px;

  @media (max-width: $breakpoint-lg) {
    margin-top: 40px;
  }

  @media (max-width: $breakpoint-md) {
    margin-top: 40px;
  }
}

.s-section {
  & + .s-section--inverse {
    margin-top: 16px;

    @media (max-width: $breakpoint-lg) {
      margin-top: 32px;
    }

    @media (max-width: $breakpoint-md) {
      margin-top: 24px;
    }
  }

  & + .s-section--gray {
    margin-top: 16px;

    @media (max-width: $breakpoint-lg) {
      margin-top: 32px;
    }

    @media (max-width: $breakpoint-md) {
      margin-top: 24px;
    }
  }

  & + .s-section--bordered {
    margin-top: 16px;

    @media (max-width: $breakpoint-lg) {
      margin-top: 32px;
    }

    @media (max-width: $breakpoint-md) {
      margin-top: 24px;
    }
  }
}

.s-section--bordered {
  padding-top: 64px;
  padding-bottom: 64px;
  border-top: 1px solid $sectionBorder;
  border-bottom: 1px solid $sectionBorder;

  @media (max-width: $breakpoint-md) {
    padding-top: 40px;
    padding-bottom: 40px;
  }

  &:last-of-type {
    margin-bottom: 0;
  }

  & + .s-section {
    margin-top: 16px;

    @media (max-width: $breakpoint-lg) {
      margin-top: 32px;
    }

    @media (max-width: $breakpoint-md) {
      margin-top: 24px;
    }
  }

  & + .s-section--inverse, & + .s-section--bordered, & + .s-section--gray {
    margin-top: 0;
  }
}

.s-section--bordered-top {
  border-top: 1px solid $sectionBorder;
}

.s-section--gray {
  padding-top: 64px;
  padding-bottom: 64px;
  background-color: rgba(217, 217, 214, 0.3);

  @media (max-width: $breakpoint-md) {
    padding-top: 40px;
    padding-bottom: 40px;
  }

  & + .s-section {
    margin-top: 16px;

    @media (max-width: $breakpoint-lg) {
      margin-top: 32px;
    }

    @media (max-width: $breakpoint-md) {
      margin-top: 24px;
    }
  }

  & + .s-section--inverse, & + .s-section--bordered, & + .s-section--gray {
    margin-top: 0;
  }

  &:last-of-type {
    margin-bottom: 0;
  }
}

.s-section--gray + .s-section--gray {
  border-top: 1px solid $sectionBorder;
}

.s-section--inverse {
  padding-top: 64px;
  padding-bottom: 64px;
  color: #FFF;
  background-color: $primary;

  @media (max-width: $breakpoint-md) {
    padding-top: 40px;
    padding-bottom: 40px;
  }

  &:last-of-type {
    margin-bottom: 0;
  }

  & + .s-section {
    margin-top: 16px;

    @media (max-width: $breakpoint-lg) {
      margin-top: 32px;
    }

    @media (max-width: $breakpoint-md) {
      margin-top: 24px;
    }
  }

  & + .s-section--inverse, & + .s-section--bordered, & + .s-section--gray {
    margin-top: 0;
  }
}

.s-section--sub {
  padding-top: 0;
  padding-bottom: 32px;

  @media (max-width: $breakpoint-md) {
    padding-bottom: 24px;
  }

  & ~ & {
    padding-top: 32px;

    @media (max-width: $breakpoint-md) {
      padding-top: 24px;
    }
  }

  &:last-child {
    padding-bottom: 0;
  }

  .s-section__subtitle {
    @media (min-width: $breakpoint-xl + 1) {
      margin-top: 0;
    }
  }

  &:last-of-type {
    margin-bottom: 0;
  }
}

.s-section__header {
  margin-bottom: 40px;

  @media (max-width: $breakpoint-lg) {
    margin-bottom: 32px;
  }

  @media (max-width: $breakpoint-md) {
    margin-bottom: 24px;
  }
}

.s-section__title {
  max-width: 766px;
  margin-bottom: 0;
  text-align: left;

  &--center {
    margin-left: auto;
    margin-right: auto;
    text-align: center;

    @media (max-width: $breakpoint-md) {
      margin-left: 0;
      text-align: left;
    }
  }
}

.s-section__subtitle {
  max-width: 776px;
  margin-top: 24px;

  @media (max-width: $breakpoint-lg) {
    margin-top: 16px;
  }

  &--center {
    margin-left: auto;
    margin-right: auto;
    text-align: center;

    @media (max-width: $breakpoint-md) {
      text-align: left;
    }
  }
}

.s-section__description {
  margin: 0 auto 48px;
  max-width: 720px;

  &--center {
    text-align: center;
  }
}
</style>